import Footer from '@/components/footer';
import HomeBanner from './banner';
import GitcoinCard from './gitcoinActivity';
import HowInvolve from './howInvolve';
import HowToUse from './howToUse';
import HowVitaeWork from './howVitaeWork';
import WhatIsVitae from './whatIsVitae';
import WhatStandOut from './whatStandOut';

const Home = (): JSX.Element => {
  return (
    <div>
      <HomeBanner />
      <GitcoinCard />
      <WhatIsVitae />
      <HowToUse />
      <WhatStandOut />
      <HowVitaeWork />
      <HowInvolve />
      <Footer />
    </div>
  );
};

export default Home;
